exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body[data-v-63bcf0b3]{table-layout:fixed!important}@media only screen and (min-width:320px) and (max-width:767px){.Mobile-Btn[data-v-63bcf0b3]{width:100%!important;margin-bottom:5px;margin-left:0!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-63bcf0b3","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/dashboard/DailyVehicleTrack.vue
// module id = 1649
// module chunks = 0